import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from '../Text';
import { Button } from './styles';

class BackButton extends Component {
  static propTypes = {
    children: PropTypes.string
  };

  static defaultProps = {
    children: 'Back to Dealer Index'
  };

  render() {
    const { children } = this.props;

    return (
      <Button>
        <Text.H3>
          <Text.H3 tag="span" color="red" font="icon">{` `}</Text.H3>
          {children}
        </Text.H3>
      </Button>
    );
  }
}

export default BackButton;
